<template>
  <div>
    <v-container>
      <v-row>
      <v-col cols="12" md="8" offset-md="2" class="d-flex justify-space-between">
        <h1 class="ml-2">My Pets</h1>
        <v-btn float="right" class="mt-2" @click="$router.push({name: 'AddPet'})">Add Pet</v-btn>
      </v-col>
      <v-spacer />
      </v-row>
      <v-row>
        <v-col cols="12" md="8" offset-md="2">
          <v-data-table
              :headers="[
                  { text: 'Name', value: 'name' },
                  { text: 'Actions', value: 'actions', width: '50px', sortable: false },
                ]"
              :loading="loading"
              :items="items"
              :footer-props="{
                    itemsPerPageOptions: [5, 10, 25, 50, 100]
                }"
          >
            <template v-slot:item.name="{ item }">
              <div class="py-3">
                <v-avatar color="primary" class="mr-3">
                  <v-img v-if="item.avatar_location !== null" :src="item.avatar_location"></v-img>
                  <span v-else class="white--text headline">{{ item.name.charAt(0) }}</span>
                </v-avatar>
                {{ item.name }}
              </div>
            </template>
            <template v-slot:item.actions="{ item }">
              <router-link :to="{name: 'ViewPet', params: {id: item.uuid}}" :key="item.id" tag="span">
                <v-btn>Edit</v-btn>
              </router-link>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>

import {mapGetters} from "vuex";
import PetsRepository from "@/api/PetsRepository";

export default {
  name: 'ViewPets',
  title: 'My Pets',
  components: {
  },
  mounted() {
   this.load()
  },
  data: () => ({
    items: [],
    page: 1,
    lastPage: 1,
    loading: false,
    selected: null,
    total: 0,
  }),
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters({
      user: 'auth/user'
    }),
  },
  methods: {
    load: async function() {
      this.loading = true;
      let response = await PetsRepository.index();
      this.items = response.data;
      this.loading = false;
    },
  },
  watch: {
    page(value) {
      this.load(value)
    },
  },
}
</script>